exports.components = {
  "component---src-page-js": () => import("./../../../src/Page.js" /* webpackChunkName: "component---src-page-js" */)
}

